import Theme from 'core/themes/model'
import checkboxStyles from '../checkboxStyles'

const deleteVmStyles = (theme: Theme) => ({
  ...checkboxStyles(theme),
  overviewBox: {
    display: 'grid',
    gap: 12,
    borderRadius: 4,
    border: `1px solid ${theme.palette.grey[200]}`,
    background: theme.palette.grey[50],
    padding: '16px 24px 16px 16px',
  },
  topBox: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  topBoxLinkContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  boxLink: {
    cursor: 'pointer',
  },
  caret: {
    marginLeft: 8,
  },
  divider: {
    height: '1px',
    background: '#D9D9D9',
  },
  titleContainer: {
    display: 'grid',
    gap: theme.spacing(1),
    margin: theme.spacing(2, 0, 2, 0),
  },
  subTitleContainer: {
    display: 'flex',
    gap: theme.spacing(2),
  },
  verticalDivider: {
    height: '100%',
    width: '1px',
    background: theme.palette.grey[200],
  },
  info: {
    background: theme.palette.grey[50],
  },
  detailedContainer: {
    display: 'grid',
    gap: 32,
  },
  spaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 8,
  },
  circleIcon: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
    height: 24,
    borderRadius: '50%',
    marginRight: 8,
  },
  blueCircle: {
    background: theme.palette.blue[200],
  },
  blueIcon: {
    color: theme.palette.blue[900],
  },
  greenCircle: {
    background: theme.palette.green[200],
  },
  darkGreenIcon: {
    color: theme.palette.green[700],
    fontSize: 24,
  },
  greenIcon: {
    color: theme.palette.green[900],
  },
  redCircle: {
    background: theme.palette.red[200],
  },
  darkRedIcon: {
    color: theme.palette.red[700],
    fontSize: 24,
  },
  redIcon: {
    color: theme.palette.red[900],
  },
  simpleResultsTable: {
    display: 'grid',
    gridTemplateColumns: 'max-content auto',
    gap: 24,
  },
  simpleResultsSpinner: {
    marginRight: 8,
    color: theme.palette.blue[700],
  },
  detailedDeleteBoxes: {
    display: 'grid',
    gap: 8,
  },
  detailedDeleteBox: {
    background: theme.palette.grey[50],
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: 4,
    display: 'grid',
    gridTemplateColumns: 'max-content auto',
    gap: 16,
    padding: '12px 24px',
    alignItems: 'center',
  },
  accordionDeleteBox: {
    padding: '12px 0px',
    display: 'grid',
    gridTemplateColumns: 'max-content auto',
    gap: 16,
    alignItems: 'center',
  },
  marginRight: {
    marginRight: 8,
  },
  successText: {
    color: theme.palette.green[700],
  },
  errorText: {
    color: theme.palette.red[700],
  },
})

export default deleteVmStyles
